<ol class='breadcrumb'>
  <li *ngFor='let breadcrumb of breadcrumbs; let last = last'>
    <span (click)='navigate(breadcrumb.url)' [ngClass]="{'last-child' : last}"
          class='cursor-pointer' routerLinkActive='router-link-active'>
      {{ breadcrumb.label | translate }}
    </span>
  </li>
</ol>
